export default __webpack_public_path__ + "static/media/img1.6b696d4f.png";